export default __webpack_public_path__ + "static/apple-icon-180x180-f1a11f4fda606a97d3198e0427a110d4.png";